module.exports = __webpack_public_path__ + "img/articleDevenirParent2.5a89190c.png";